module.exports = __webpack_public_path__ + "assets/img/zhijiaob_2013_3.246ab0b6.jpg";